import * as React from "react";
import { Link } from "react-router";
import { Crumb as WebuiCrumb } from "@stenajs-webui/elements";

interface Props {
  label: string;
  path?: string;
  dataTestid?: string;
}

export const Crumb: React.FC<Props> = ({ label, path, dataTestid }) => {
  return (
    <div data-testid={dataTestid}>
      <WebuiCrumb
        label={label.toUpperCase()}
        render={path ? (props) => <Link {...props} to={path} /> : undefined}
      />
    </div>
  );
};
